import { useEffect, useState } from 'react';
import api from '../../../lib/apiClient';
import ReportView, { type ReportColumn, type ReportOption } from '../../../components/reports/ReportView';

const COLUMNS: ReportColumn[] = [
  { key: 'user_name', label: 'Employee' },
  { key: 'email', label: 'Email' },
  { key: 'mobile', label: 'Mobile' },
  { key: 'job_title', label: 'Job Title' },
  { key: 'department', label: 'Department' },
  { key: 'manager', label: 'Manager' },
];

export function EmployeeRegisterReport() {
  const [orgUnitOptions, setOrgUnitOptions] = useState<ReportOption[]>([]);

  useEffect(() => {
    api
      .get<{ id: number; unit_name: string }[]>('/org-units')
      .then((res) => setOrgUnitOptions(res.data.map((u) => ({ value: String(u.id), label: u.unit_name }))));
  }, []);

  return (
    <ReportView
      title="Employee Register"
      description="Full employee listing with contact details, current position and manager."
      endpoint="/reports/hr/employees"
      columns={COLUMNS}
      filters={['category']}
      categoryOptions={orgUnitOptions}
    />
  );
}
